import { compose, lifecycle } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import VerifyEmail from './components/VerifyEmail';
import { verifyBarberEmail, verifyCustomerEmail } from './actions';

const VerifyEmailContainer = verifyEmail => compose(
  withRouter,
  connect(
    (state, ownProps) => ({
      isFetching: state.confirmation.get('isFetching'),
      errorMessage: state.confirmation.get('errorMessage'),
      successMessage: state.confirmation.get('successMessage'),
      token: ownProps.params.token,
    }),
    { verifyEmail }
  ),
  lifecycle({
    componentDidMount() {
      this.props.verifyEmail(this.props.token);
    },
  })
)(VerifyEmail);

export default VerifyEmailContainer;

export const CustomerVerifyEmail = VerifyEmailContainer(verifyCustomerEmail);
export const BarberVerifyEmail = VerifyEmailContainer(verifyBarberEmail);



// WEBPACK FOOTER //
// ./src/app/confirmation/VerifyEmail.jsx